'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoTransgender = function IoTransgender(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 0h11.2v11.3h-3.1v-6l-7.9 7.8c0.6 1.4 1 2.8 1 4.4 0 4.9-3.6 9-8.1 9.8v4.1h5.6v3.6h-5.6v5h-3.8v-5h-5.6v-3.6h5.6v-4.1c-4.6-0.8-8.1-4.9-8.1-9.8 0-1.6 0.4-3 1-4.4l-1.7-1.7-2.8 2.8-2.6-2.6 2.8-2.8-3.6-3.5v6h-3.1v-11.3h11.3v3.1h-5.5l3.3 3.3 2.9-2.8 2.5 2.6-2.8 2.8 1.3 1.3c1.8-1.7 4.3-2.8 7-2.8 2.1 0 4.1 0.6 5.8 1.8 0 0 0.5 0.4 1.2 1l7.2-7.2h-5.5v-3.1z m-8.8 23.8c3.4 0 6.3-2.9 6.3-6.3s-2.9-6.2-6.3-6.2-6.2 2.8-6.2 6.2 2.8 6.3 6.2 6.3z' })
        )
    );
};

exports.default = IoTransgender;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/transgender.js
// module id = 2992
// module chunks = 168707334958949